import { render, staticRenderFns } from "./WizardCompanyInfoStep.vue?vue&type=template&id=2bdb428a&"
import script from "./WizardCompanyInfoStep.vue?vue&type=script&lang=js&"
export * from "./WizardCompanyInfoStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/allianzebpo/public_html/payment/crater/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bdb428a')) {
      api.createRecord('2bdb428a', component.options)
    } else {
      api.reload('2bdb428a', component.options)
    }
    module.hot.accept("./WizardCompanyInfoStep.vue?vue&type=template&id=2bdb428a&", function () {
      api.rerender('2bdb428a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/wizard/WizardCompanyInfoStep.vue"
export default component.exports